/**
 * Entry-Point FactoryERP Frontend.
 *
 * Provider-Kette: QueryClient → AuthProvider → Router.
 * Auth läuft seit issue #6 über oidc-client-ts gegen die Lehner-Authentik-
 * Instanz (PKCE public client, kein Provider-Wrapper eines SDK mehr nötig).
 * Ohne OIDC-Konfiguration (window.__ENV__ / VITE_*) ist der AuthProvider ein
 * No-op, so läuft der Scaffold lokal auch OHNE IdP (LEH-001-Verhalten).
 */

import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"

import App from "./App"
import { AuthProvider } from "./providers/AuthProvider"
import "./index.css"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
})

const tree = (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
    <Toaster position="top-right" richColors />
  </QueryClientProvider>
)

createRoot(document.getElementById("root")!).render(<StrictMode>{tree}</StrictMode>)
